import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { IonicSlides, ModalController } from '@ionic/angular';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-image-slider',
    templateUrl: './image-slider.component.html',
    styleUrls: ['./image-slider.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ImageSliderComponent extends BaseInjectorService implements OnInit {
  startSlideIndex: number;
  zoomOption;
  showSlider:boolean= false;
  imagesList:any=[];
  imgIndex:any;
  sliderImages:any;
  arrowLeft:any;
  arrowRight:any;
  current:any;
  swiperModules = [IonicSlides];
  
  constructor(private modal: ModalController) {
    super()
   }
  async ngOnInit(){

    this.sliderImages = document.querySelectorAll(".slide"),
    this.arrowLeft = document.querySelector("#arrow-left"),
    this.arrowRight = document.querySelector("#arrow-right"),
    this.current = 0;
    if(this.imagesList.length){
      for (let index = 0; index < this.imagesList.length; index++) {
        this.startSlideIndex=this.imgIndex;
      }
    }

    this.zoomOption = {
      initialSlide:   this.startSlideIndex,
      zoom: {
        minRatio: 1,
        maxRatio: 3,
      }
    };
  }

  dismissSlider(){
    this.modal.dismiss();
  }

  removeSelectedImage(image) {
    let index = this.imagesList.indexOf(image);
    if (index > -1) {
      this.imagesList.splice(index, 1);
    }
    if(this.imagesList.length==0){
      this.dismissSlider();
    }
  }

  arrow_left(){
    let leftslide = document.getElementById('arrow-left')
    if (this.current === 0) {
    	this.current = this.sliderImages.length;
    }
    this.slideLeft();
  }
  arrow_right(){
    if (this.current === this.sliderImages.length - 1) {
    	this.current = -1;
    }
    this.slideRight();
  }

  slideLeft() {
    if(this.sliderImages.length>0){
    this.sliderImages[this.current - 1].style.display = "block";
    this.current--;
    }
    }
  slideRight() {
      if(this.sliderImages.length>0){
        this.sliderImages[this.current + 1].style.display = "block";
        this.current++;
      }
    }
  
}
